module.exports = __webpack_public_path__ + "img/additional-settings.a829f544.png";